<template>
  <el-container>
    <img class="backgroundimg" :src="backgroundimg" />
    <div style="height:16vh;width: 100%;"></div>
    <el-main  @keyup.enter.navite="keyDown">
      <p class="title">{{ $t('Login.title') }}</p>
      <el-input :placeholder="$t('Login.database')" maxlength="15" v-model="userinfo.database"><svg-icon slot="prefix"
          icon-class="database" /></el-input>
      <el-input :placeholder="$t('Login.userId')" maxlength="20" v-model="userinfo.userId"><svg-icon slot="prefix"
          icon-class="account" /></el-input>
      <el-input :placeholder="$t('Login.password')" v-model="userinfo.password" show-password><svg-icon slot="prefix"
          icon-class="password" /></el-input>
      <div class="operation">
        <el-checkbox v-model="reminfo" size="mini">{{ $t('Login.rempsaaword') }}</el-checkbox>
        <el-select v-model="lang" @change="changelang" size="mini">
          <el-option v-for="item in langinfo" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <el-button @click="doLogin" @keydown.enter.native.prevent="notopration" type="primary">{{ $t('Login.login') }}</el-button>
      <!-- // ADV202306050013 新版供应商，调整移除环境配置，不做插件的安装功能  -->
      <div class="screentip">{{ $t('Login.screentip') }}</div>
      <div class="screentip" style="padding-top: 5px;">{{ $t('Login.webVersion') }}:{{ webVersion }} </div>
    </el-main>
    <DialogChangePwd ref="dialog" :userId="userinfo.userId" :groupId="userinfo.database" :changeSucess="changesucess"></DialogChangePwd>
    <el-footer>
      <!-- <div class="copyright">{{ webSupCopyRight }} &nbsp;&nbsp;<span @click="linkHref();">{{ internetContentProvider }}</span></div> -->
    </el-footer>
  </el-container>
</template>
  
<script>
import SvgIcon from "@/components/SvgIcon"
import { loadAndUpdateVersion,platformLogin } from "@/utils/utils";
import DialogChangePwd from '@/components/DialogChangePwd';
export default {
  components: {
    SvgIcon,
    DialogChangePwd
  },
  name: 'Login',
  props: {
    msg: String
  },
  data() {
    return {
      loginDate:'',
      reminfo: false,
      relogin: false, //是否强制登录
      unCheckPwdValidateDate: false, //不验证密码有效期（false默认验证）
      langinfo: [{
        value: 'zh-CHS',
        label: '中文简体(切换)'
      }, {
        value: 'zh-CHT',
        label: '中文繁體(切換)'
      },{
        value:'en',
        label:'English(Switch)'
      }],
      userinfo: {
        database: "",
        userId: "",
        password: ""
      },
      value: "zh-CHS",
      lang: "中文简体(切换)",
      enter:true,
      backgroundimg:require('../assets/img/Login/AgencyBg.png'),
      webSupCopyRight:'',
      internetContentProvider:'',
      internetContentProviderHref:'',
      dontcheckbrowser:false,
      webVersion:''
    }
  },
  created() {
    localStorage.setItem("PlatformPath","AgencyComm");
    if(localStorage.getItem("PCBackgroundImg")&&localStorage.getItem("PCBackgroundImg")!=""){
            this.backgroundimg = localStorage.getItem("PCBackgroundImg");
          }
    this.getUserConfig();
    this.keyDown();
  },
  methods: {
    keyDown() {
      document.onkeydown = ev => {
        if (this.$route.path == "/Login" && typeof(ev.key)!='undefined' && ev.key.toLowerCase() === 'enter' &&  this.$refs.dialog.dialogFormVisible == false && this.enter) //enter键触发登录
        {
          console.log(this.$route.path);
          this.doLogin();
        }
      }
    },
    //检查三个输入框是否为空
    checkEmpty() {
      if (!this.userinfo.database) {
        this.$store.commit("TIPPOP",{popType:'error',popMessage:this.$t("Login.databaseText")});
        return false;
      } else if (!this.userinfo.userId) {
        this.$store.commit("TIPPOP",{popType:'error',popMessage:this.$t("Login.userIdText")});
        return false;
      } else if (!this.userinfo.password) {
        this.$store.commit("TIPPOP",{popType:'error',popMessage:this.$t("Login.passwordText")});
        return false;
      } else return true;
    },
    notopration(){},
    //登录按钮触发的事件
    doLogin() {
      platformLogin.call(this,"agency");
    },
    changesucess(newpwd){
      this.unCheckPwdValidateDate = true;
      this.userinfo.password = newpwd;
      this.doLogin();
    },
      
    //获取账套信息
    getUserConfig() {
      const cookieload = this.$loading({
          lock: true,
          text: this.$t('Login.cookieload'),
          spinner: 'el-icon-loading',
          background: 'rgba(0,0,0,0.7)'
        });
      this.axiosInvoke("/AgencyComm/Handler/LoginHandler.ashx", {
        action: "getuserconfig",
      },
        res => {
          cookieload.close();
          let data = eval(res.data);
          console.log(data);
          this.loginDate = data[0].loginDate;
          this.userinfo.database = data[0].groupId;
          this.userinfo.userId = data[0].userId;
          this.userinfo.password = data[0].xPassword;
          this.dontcheckbrowser = data[0].dontcheckbrowser;
          this.reminfo = data[0].rememberme=="on"?true:false;
          if(data[1].Title&&data[1].Title!=""){
            this.title = data[1].Title;
          }
          if(data[1].BackgroundImg&&data[1].BackgroundImg!=""){
            this.backgroundimg = data[1].BackgroundImg;
            localStorage.setItem("PCBackgroundImg",data[1].BackgroundImg);
          }else{
            this.backgroundimg = require('../assets/img/Login/AgencyBg.png');
            localStorage.removeItem("PCBackgroundImg");
          }
          if(data[1].WebSupCopyRight && data[1].WebSupCopyRight!="")
          {
            this.webSupCopyRight = data[1].WebSupCopyRight;
          }
          this.webVersion =  data[1].webVersion;
          if(data[1].InternetContentProvider && data[1].InternetContentProvider!="")
          {
            this.internetContentProvider = data[1].InternetContentProvider;
          }
          if(data[1].InternetContentProviderHref && data[1].InternetContentProviderHref!="")
          {
            this.internetContentProviderHref = data[1].InternetContentProviderHref;
          }
          if(data[1].LoginDefaultLang && data[1].LoginDefaultLang!="" && (data[1].language == "" || !data[1].language))
          {
            this.value = data[1].LoginDefaultLang;
              this.changelang(this.value);
          }
          if(data[1].language != ""){
            this.value = data[1].language;
            this.changelang(this.value);
          }
          if(!sessionStorage.getItem("loginDate")){
            loadAndUpdateVersion(this); 
          };
          if(!this.loginDate){
            loadAndUpdateVersion(this);
          }
          if(!this.dontcheckbrowser){
            this.checkBrowser();
          }
          if(data[1].IsA10){
            sessionStorage.setItem("VersionType","A10");
          }
        })
    },
    linkHref(){
      if(this.internetContentProviderHref && this.internetContentProviderHref !=""){
        window.open(this.internetContentProviderHref);
      }
    },
    //语言选择时触发的事件
    changelang(value) {
      this.langinfo.filter((x) => {
        if (x.value == value) {
          this.lang = x.label;
          this.value = x.value;
          this.$i18n.locale = this.value;
        }
      })
    },
    configselect(value) {
      console.log(value);
    },
  
    checkBrowser(){
      var BrowserVision = "";
      var type = "";
      var userAgent = navigator.userAgent;
      var BeginIndex = -1;
      var EndIndex = -1;
      if(userAgent.indexOf("Chrome")>0){
        BeginIndex = userAgent.indexOf("Chrome")+7;
        EndIndex = BeginIndex+userAgent.substring(BeginIndex).indexOf(".");
        BrowserVision = userAgent.substring(BeginIndex,EndIndex);
        type = "Chrome";
      }else if(userAgent.indexOf("Firefox")>0){
        BeginIndex = userAgent.indexOf("Firefox")+8;
        EndIndex = BeginIndex+userAgent.substring(BeginIndex).indexOf(".");
        BrowserVision = userAgent.substring(BeginIndex,EndIndex);
        type = "Firefox";
      }
      if(!isNaN(BrowserVision)){
        var tipinform = "";
        var tipbox = false;
        if(type == "Chrome" && Number(BrowserVision)<80){
          tipinform = this.$t('Login.chromeoutdate');
          tipbox = true;
        }else if(type == "Firefox" && Number(BrowserVision)<80){
          tipinform = this.$t('Login.firefoxoutdate');
          tipbox = true;
        }
        if(tipbox){
          this.$confirm(tipinform,this.$t('Login.prompt'),{
            confirmButtonText:this.$t('Login.outdatecancel'),
            cancelButtonText:this.$t('Login.outdateconfirm'),
            type:'warning'
          }).then(()=>{
            this.$cookies.set("dontcheckbrowser", "dontcheck","30D");
          }).catch(()=>{
          });
        }
      }
    }
  }
}

String.prototype.format = function () {
  if (arguments.length == 0) return this;
  for (var s = this, i = 0; i < arguments.length; i++) {
    s = s.replace(new RegExp("\\{" + i + "\\}", "g"), arguments[i]);
  }
  return s;
}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-container {
  height: 100vh;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0;
  margin: 0;
}

.el-main {
  text-align: center;
}

.operation {
  width: 384px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto 20px auto;
}

.el-button {
  width: 382px;
  letter-spacing: 6px;
}

.el-main {
  background-image: url(@/assets/img/Login/containerbg.png);
  background-repeat: no-repeat;
  background-size: cover;
  width: 590px;
  height: 475px;
  padding: 0;
  border-radius: 8px;
  flex: none;
}

.title {
  font-size: 31.5px;
  color: #0375f9;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "PingFang TC", "Hiragino Sans GB",'Source Han Sans SC Regular','Source Han Sans TC Regular','Alibaba PuHuiTi 2.0','Alibaba PuHuiTi 3.0', "Microsoft YaHei", "Microsoft JhengHei",sans-serif;;
  margin: 37px 0 37px 0;
}

.el-input {
  width: 384px;
  margin-bottom: 20px;
  font-size: 19px;
  color: #999999;
}

.el-input /deep/ .el-input__inner {
  border-radius: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "PingFang TC", "Hiragino Sans GB",'Source Han Sans SC Regular','Source Han Sans TC Regular','Alibaba PuHuiTi 2.0','Alibaba PuHuiTi 3.0', "Microsoft YaHei", "Microsoft JhengHei",sans-serif;;
}

.el-input /deep/ .el-input__inner::-webkit-input-placeholder {
  color: #999999;
}

.svg-icon {
  width: 1.15rem;
  height: 1.15rem;
  margin: 0.6rem 0.1rem;
}

.el-checkbox {
  zoom: 115.5%;
  color: #0375f9;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "PingFang TC", "Hiragino Sans GB",'Source Han Sans SC Regular','Source Han Sans TC Regular','Alibaba PuHuiTi 2.0','Alibaba PuHuiTi 3.0', "Microsoft YaHei", "Microsoft JhengHei",sans-serif;;
}

.el-select /deep/.el-input__inner {
  width: 8.3rem;
  text-align: right;
  padding: 0;
  border: none;
  background-color: rgba(255, 255, 255, 0);
  color: #999999;
  font-size: 16px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "PingFang TC", "Hiragino Sans GB",'Source Han Sans SC Regular','Source Han Sans TC Regular','Alibaba PuHuiTi 2.0','Alibaba PuHuiTi 3.0', "Microsoft YaHei", "Microsoft JhengHei",sans-serif;;
}

.el-select /deep/.el-icon-arrow-up:before {
  content: none;
}

.el-button {
  border: none;
  border-radius: 0;
  padding: 5px;
  font-size: 22px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "PingFang TC", "Hiragino Sans GB",'Source Han Sans SC Regular','Source Han Sans TC Regular','Alibaba PuHuiTi 2.0','Alibaba PuHuiTi 3.0', "Microsoft YaHei", "Microsoft JhengHei",sans-serif;;
  background-image: url(@/assets/img/Login/loginbtn.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.environment {
  margin: 12px auto 10px;
  width: 384px;
  text-align: right;
}

.environment /deep/ .el-input__inner {
  width: 5.3rem;
  font-size: 15px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "PingFang TC", "Hiragino Sans GB",'Source Han Sans SC Regular','Source Han Sans TC Regular','Alibaba PuHuiTi 2.0','Alibaba PuHuiTi 3.0', "Microsoft YaHei", "Microsoft JhengHei",sans-serif;;
  color: #0375f9;
}

.copyright {
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "PingFang TC", "Hiragino Sans GB",'Source Han Sans SC Regular','Source Han Sans TC Regular','Alibaba PuHuiTi 2.0','Alibaba PuHuiTi 3.0', "Microsoft YaHei", "Microsoft JhengHei",sans-serif;;
  font-size: 18px;
  margin-top: 7vh;
}

.copyright span {
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "PingFang TC", "Hiragino Sans GB",'Source Han Sans SC Regular','Source Han Sans TC Regular','Alibaba PuHuiTi 2.0','Alibaba PuHuiTi 3.0', "Microsoft YaHei", "Microsoft JhengHei",sans-serif;;
  font-size: 18px;
  cursor: pointer;
}
.screentip {
  color: #999999;
  padding-top: 30px;
}
.backgroundimg{
  position: fixed;
  height: 100vh;
  width: 100vw;
  min-width: 1080px;
  min-height: 600px;
  z-index: -999;
}
</style>
  